import FeaturedVideo from './FeaturedVideo'
import GeneralContent from './GeneralContent'
import GeneralEvent from './GeneralEvent'
import Playlist from './Playlist'
import Quote from './Quote'

/**
 * Map between content type (from Strapi) with the template component used to render that content
 *
 * There are "duplicate" (camelCase / kebab-case) keys because depending on how we request the content
 * (as relations of a zone or directly as a content type), the type is called different
 * on the backend.
 */

const TEMPLATES_MAP = {
  // generalEvents: GeneralEvent,
  // 'general-events': GeneralEvent,
  // 'featured-videos': FeaturedVideo,
  // featuredVideos: FeaturedVideo,
  // generalContents: GeneralContent,
  // 'general-contents': GeneralContent,
  quotes: Quote,
  general_events: GeneralEvent,
  featured_videos: FeaturedVideo,
  general_contents: GeneralContent,
  playlists: Playlist,
}

export { TEMPLATES_MAP, FeaturedVideo, GeneralEvent, GeneralContent, Playlist, Quote }
